import React, { useState } from 'react';
import styled from 'styled-components';

import MetaTags from 'components/meta-tags';
import { EmailCodeLoginForm } from 'components/forms/email-code-login';
import type { LoginStep } from 'components/forms/email-code-login';

export type EnterpriseSignupContentProps = {
  dispensaryId?: string;
  onLoginSuccess?: () => void;
};

export function EnterpriseSignupContent({ dispensaryId, onLoginSuccess }: EnterpriseSignupContentProps): JSX.Element {
  const [step, setStep] = useState<LoginStep>('email');
  // The profile step (CompleteAccount) renders its own heading, so hide this card's header then.
  const showHeader = step !== 'profile';

  const handleStepChange = (newStep: LoginStep): void => {
    setStep(newStep);
  };

  return (
    <>
      <MetaTags title='enterprise.signup.title' description='enterprise.signup.description' />

      <SignupContainer>
        <SignupWrapper>
          {showHeader && (
            <SignupHeader>
              <SignupTitle>Almost there! Set up your account</SignupTitle>
              <SignupSubtitle>Choose how you would like to sign up and start earning rewards today!</SignupSubtitle>
            </SignupHeader>
          )}

          <EmailCodeLoginForm
            dispensaryId={dispensaryId}
            showMedicalCardForm
            analyticsEventLabel='enterprise-signup'
            analyticsSurface='enterpriseSignup'
            onStepChange={handleStepChange}
            onLoginSuccess={onLoginSuccess}
          />
        </SignupWrapper>
      </SignupContainer>
    </>
  );
}

// Styled Components for Enterprise Signup Content
const SignupContainer = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f9fafb;
  padding: 1rem;
`;

const SignupWrapper = styled.div`
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 2rem;
  width: 100%;
  max-width: 500px;
`;

const SignupHeader = styled.div`
  text-align: center;
  margin-bottom: 1.5rem;
`;

const SignupTitle = styled.h1`
  font-size: 1.5rem;
  font-weight: 600;
  color: #1f2937;
  margin: 0 0 0.5rem 0;
`;

const SignupSubtitle = styled.p`
  color: #6b7280;
  margin: 0 0 1rem 0;
`;
